import React from 'react'
import { EdifyDataGrid } from '../../components/datagrid/EdifyDataGrid'
import { GridRowParams, GridRowSelectionModel } from '@mui/x-data-grid'

import BulkDeleteButton from '../../components/buttons/BulkButtons/BulkDeleteButton'
import pluralize from 'pluralize'

import {
  createSingleColumnWithForm,
  normalizeFormNotificationsForDataGrid,
} from '../../components/datagrid/userFormNotificationCreate'
import { useSubscriptionPageViewModel } from '../subscriptions/SubscriptionPageViewModel'
import {
  normalizeFormNotificationForReadDataGrid,
  userFormNotificationReadColumns,
} from '../../components/datagrid/userFormNotificationRead'
import {
  createSubscription,
  deleteSubscription,
  updateSubscription,
} from '../../../domain/usecases/subcriptions/SubscriptionUsecases'
import { EdifyDataGridV2 } from '../../components/datagrid/EdifyDataGridV2'

interface IUserFormNotificationsDataGridProps {
  title: string
  rows?: any
  checkboxSelection?: boolean
  error?: string
  totalCount?: number
  readonly?: boolean
  showAll?: boolean
  getCurrentRowData?: any
  updateRowState?: any
  rowStates?: any
}

const UserFormNotificationsDataGrid: React.FC<IUserFormNotificationsDataGridProps> = ({
  title,
  rows,
  checkboxSelection = true,
  error,
  readonly,
  showAll = false,
  totalCount = -1,
  getCurrentRowData,
  updateRowState,
  rowStates,
}) => {
  const { allFormsWithSubscriptions, allUsersFormsWithSubscriptions, isLoading } = useSubscriptionPageViewModel()

  const [selectionModel, setSelectionModel] = React.useState<GridRowSelectionModel>([])

  const canDelete = true

  const handleRowClicked = (params: GridRowParams) => {
    // don't need to do
  }

  // delete userFormNotifications/s
  const removeClicked = async () => {
    //todo
  }

  const renderHeaderButtons = () => {
    // don't render bulk action items if turned off
    if (!canDelete || !checkboxSelection) return <></>
    const noSelections = selectionModel.length === 0
    return <BulkDeleteButton noSelections={noSelections} onClick={removeClicked} />
  }

  const handleAddCB = () => {
    console.log('handleAddCB')
  }
  if (showAll && !allFormsWithSubscriptions) {
    return null
  }
  if (!showAll && !allUsersFormsWithSubscriptions) {
    return null
  }

  if (showAll) {
    return (
      <>
        <EdifyDataGridV2
          data-testid='UserFormNotificationsDataGrid'
          paginationMode='client'
          noRowsText={`No ${pluralize(title).toLocaleLowerCase()} found.`}
          title={title}
          renderHeaderButtons={renderHeaderButtons()}
          columns={createSingleColumnWithForm(createSubscription, updateSubscription, deleteSubscription)}
          rows={normalizeFormNotificationsForDataGrid(allFormsWithSubscriptions)}
          error={error}
          rowSelectionModel={selectionModel}
          setSelectionModel={setSelectionModel}
          handleRowClicked={handleRowClicked}
          loading={isLoading}
          rowCount={allFormsWithSubscriptions?.length ?? 0}
          tableRowHeight={220}
          checkboxSelection={checkboxSelection && canDelete}
          clientSideProcessing={true}
          initSort={[
            {
              field: 'formName',
              sort: 'asc',
            },
          ]}
        />
      </>
    )
  }

  return (
    <>
      <EdifyDataGridV2
        data-testid='UserFormNotificationsDataGridRead'
        noRowsText={`No ${pluralize(title).toLocaleLowerCase()} found.`}
        title={title}
        renderHeaderButtons={renderHeaderButtons()}
        columns={userFormNotificationReadColumns}
        rows={normalizeFormNotificationForReadDataGrid(allUsersFormsWithSubscriptions, readonly, showAll)}
        error={error}
        rowSelectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        handleRowClicked={handleRowClicked}
        loading={isLoading}
        rowCount={allUsersFormsWithSubscriptions?.length ?? 0}
        checkboxSelection={checkboxSelection && canDelete}
        clientSideProcessing={true}
        initSort={[
          {
            field: 'formName',
            sort: 'asc',
          },
        ]}
      />
    </>
  )
}

export default UserFormNotificationsDataGrid
